<div class="item-container">
  <div *ngFor="let option of filter.options"
       (click)="handleOptionClick(option)"
       class="option"
       [class.selected]="filter.selectedOptionValue === option.value">
    <span>{{option.label}}</span>
  </div>
</div>
